import { t } from 'i18next';
import z from 'zod';

const MAX_ID_LENGTH = 124;

// Validates a trimmed identifier string within the standard maximum ID length
export const idString = () =>
  z
    .string()
    .trim()
    .max(MAX_ID_LENGTH, t('errors:forms.string.max', { max: MAX_ID_LENGTH }));
